<!-- <app-shared-organization-topbar
  [margin]="orgTopbarMargin || '-20px -20px 24px -20px'"
></app-shared-organization-topbar> -->

<div class="wrapper" [ngClass]="{ fullWidth }" [ngStyle]="wrapperStyle">
  <div class="sidebar">
    <app-profile-sidebar></app-profile-sidebar>
  </div>

  <div class="content" [ngStyle]="contentStyle">
    <ng-content></ng-content>
  </div>
</div>
